import { IGroupMembers } from "@grassrootly/api";
import { PayloadAction, createPersistReducer, initReducer, PersistConfig } from "@grassrootly/rn-core";
import AsyncStorage from "@react-native-async-storage/async-storage";

export interface GroupMembers {
  group_members: { [key: string]: IGroupMembers };
}

const initialState: GroupMembers = {
  group_members: {},
};

const groupMembersSlice = initReducer({
  name: "group-members",
  initialState,
  reducers: {
    setGroupMembers: (state: GroupMembers, action: PayloadAction<IGroupMembers>) => {
      state.group_members[action.payload.points_earned] = action.payload;
    },
    cleanState: () => {
      return initialState;
    },
  },
});

const persistConfig: PersistConfig<GroupMembers> = {
  key: "group-members",
  storage: AsyncStorage,
};

export const groupMembersActions = groupMembersSlice.actions;

export default createPersistReducer(persistConfig, groupMembersSlice.reducer);
